import { useState, useEffect } from "react";
import "./NewVersionToast.css";
import Action from "components/formElements/Action/Action";
import { refreshWebapp, fetchLatestBuildVersion } from "services/buildVersion";
import { useUser } from "contexts/UserContext";

const FETCH_VERSION_PERIOD = 60 * 1000;

// The version this bundle was built from, baked in by vite.config.ts. Comparing
// against this rather than against the first polled value matters: previously
// `runningVersion` was seeded from the first poll, 60s after mount, so a deploy
// landing inside that window made the tab record the NEW version as its own and
// never prompt again — while still running the old, now-undeployed bundle.
const runningVersion = __BUILD_VERSION__;

const NewVersionToast = () => {
  const user = useUser(false);

  const [toastShown, setToastShown] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      try {
        const latestVersion = await fetchLatestBuildVersion();

        if (latestVersion !== runningVersion) {
          setToastShown(true);
        }
      } catch {
        // fetchLatestBuildVersion already logs; swallow so a transient network
        // blip does not raise an unhandled rejection once a minute.
      }
    }, FETCH_VERSION_PERIOD);

    return () => clearInterval(intervalId);
  }, []);

  if (toastShown && user) {
    return (
      <div className="new-version-toast">
        <div className="toast-inner">
          <span>A new version is available.</span>
          <Action className="btn" onClick={refreshWebapp}>
            REFRESH
          </Action>
        </div>
      </div>
    );
  }

  return null;
};

export default NewVersionToast;
